import edit from './edit'
import send from './send'
import guest from './guest'
import chipIn from './chip_in'
import CreatePage from 'components/pages/create'

import CountryBlockedError from 'components/common/country_blocked'
import { sendEnsightenEvent } from 'lib/ensighten_analytics'

import CrowdfundingBasics from 'components/pages/crowdfunding/crowdfunding_basics'
import CrowdfundingStory from 'components/pages/crowdfunding/crowdfunding_story'
import CrowdfundingCover from 'components/pages/crowdfunding/crowdfunding_cover'
import CrowdfundingShare from 'components/pages/crowdfunding/crowdfunding_share'
import PoolPublish from 'components/pages/crowdfunding/crowdfunding_publish'
import CampaignEligibility from 'components/common/campaign_eligibility'
import { POOLS_CAMPAIGN_TYPES, ELIGIBILITY_STATUS } from 'shared/shared_consts'
import { dexterURL } from 'shared/campaign_url'

import { updateQueryParams } from 'redux/modules/url'

import {
  NEW_CAMPAIGN_ID,
  create,
  resetRemoteOperation,
} from 'redux/modules/campaign'

import {
  getStepName,
  assertInitialStep,
  assignActionToRouterParams,
} from 'lib/route_utils'

const INITIAL_STEP = 'basics'
const { CROWD_FUNDING } = POOLS_CAMPAIGN_TYPES

export default (store, history) => ({
  path: 'create-crowdfunding',
  getComponent(nextState, callback) {
    if (store.getState().current_user.moneypools_blocked) {
      return callback(null, CountryBlockedError)
    } else if (
      store.getState().current_user.CIPStatus === ELIGIBILITY_STATUS.INELIGIBLE
    ) {
      if (store.getState().current_user.CIPStatusCode === 'NEED_MORE_DATA') {
        const returnUrl = nextState.location.pathname
        location.href = dexterURL(returnUrl)
        return
      }
      return callback(null, CampaignEligibility)
    }
    return callback(null, CreatePage)
  },
  onEnter(nextState, replace) {
    store.dispatch((d, getState) => {
      d(create(CROWD_FUNDING)) // creates the new campaign object.
      d(updateQueryParams(nextState.location)) // updates the state with query params
    })
    nextState.params.nextStep = getStepName(
      'create-crowdfunding',
      nextState.routes
    )
    if (nextState.params.nextStep !== 'share/:campaignId') {
      nextState.params.campaignId = NEW_CAMPAIGN_ID
      assertInitialStep('create-crowdfunding', INITIAL_STEP, nextState, replace)
    }
  },
  onChange(prevState, nextState) {
    assignActionToRouterParams(nextState)
    nextState.params.campaignId = NEW_CAMPAIGN_ID
    nextState.params.prevStep = getStepName(
      'create-crowdfunding',
      prevState.routes
    )
    nextState.params.nextStep = getStepName(
      'create-crowdfunding',
      nextState.routes
    )
  },
  childRoutes: [
    {
      path: INITIAL_STEP,
      component: CrowdfundingBasics,
      onEnter(nextState) {
        if (
          nextState.location.action !== 'POP' ||
          !nextState.params.prevSteps
        ) {
          sendEnsightenEvent('MoneyPoolStart')
        }
      },
    },
    { path: 'story', component: CrowdfundingStory },
    { path: 'cover', component: CrowdfundingCover },
    {
      path: 'publish',
      component: PoolPublish,
      onEnter(nextState) {
        if (nextState.location.action !== 'POP') {
          store.dispatch(resetRemoteOperation(NEW_CAMPAIGN_ID))
        }
      },
    },
    { path: 'share/:campaignId', component: CrowdfundingShare },
    edit(store, history),
    send(store, history),
    guest(store, history),
    chipIn(store, history),
  ],
})
